import React from 'react'
import { push } from '@lagunovsky/redux-react-router'
import i18n from 'simple-react-i18n'
import { useDispatch } from 'react-redux'
import { Button, Grid } from '@mui/material'

const UnauthorizedApp = () => {
    const dispatch = useDispatch()
    return (
        <Grid container sx={{ marginBottom: '20px' }}>
            <Grid size={12}>
                <div className='card '>
                    <div className='card-title activator active'>
                        <i className='material-icons no-display'>warning</i>
                        {i18n.AccessRightDeny}
                    </div>
                </div>
            </Grid>
            <Grid size='auto' sx={{ marginTop: 1 }}>
                <Button variant='contained' color='primary' onClick={() => dispatch(push('/'))}>{i18n.homepage}</Button>
            </Grid>
        </Grid>
    )
}

export default UnauthorizedApp
